export default "__VITE_ASSET__CAQR2CYU__"